export class Invitation {
    id: string;
    groupId: string;
    groupName: string;
    inviterEmail: string;
    inviteeEmail: string;
    inviterName: string;
    createdOn: any;

    constructor(res: any){
        if(res == null) return;
        this.id = res.id;
        this.groupId = res.groupId;
        this.groupName = res.groupName;
        this.inviteeEmail = res.inviteeEmail;
        this.inviterEmail = res.inviterEmail;
        this.inviterName = res.inviterName;
        this.createdOn = res.createdOn;
    }
}